import type { Policy } from 'policies-api'
import { DDSLine } from 'policies-api'
import type { MotorContract } from '@/types/motor/MotorContract'
import type { EMobilContract } from '@/types/emobil/EMobilContract'
import { isEMobilContract } from '@/types/emobil/EMobilContract'

/**
 * Checks if a policy has TechInsurance in its ddsLines
 */
export function isTechInsurancePolicy(policy: Policy): boolean {
  return policy.ddsLines?.includes(DDSLine.TechInsurance) ?? false
}

/**
 * Checks if a contract is TechInsurance but NOT an E-Bike contract
 * Based on the requirements: TechInsurance contracts with isEMobil: false
 * should be treated as generic TechInsurance (not E-Bike)
 */
export function isTechInsuranceNonEBikeContract(
  contract: MotorContract | EMobilContract | null,
  policy?: Policy
): boolean {
  if (!contract) return false

  // Check if policy has TechInsurance ddsLine
  const hasTechInsuranceDdsLine = policy ? isTechInsurancePolicy(policy) : false

  // Must be an EMobilContract (not a regular MotorContract)
  if (!isEMobilContract(contract)) {
    return false
  }

  // Check if contract is NOT E-Bike
  // E-Bike contracts have isEMobil: true
  const isEBike = contract.isEMobil === true

  return hasTechInsuranceDdsLine && !isEBike
}
